import { render, staticRenderFns } from "./VAssetArchive.vue?vue&type=template&id=04e8f440&"
import script from "./VAssetArchive.vue?vue&type=script&lang=js&"
export * from "./VAssetArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports